// @flow
import React, { Component } from 'react';
import addZendeskScriptElement from 'app/common/lib/Zendesk';
import type { Viewer } from 'app/packages/pinterest-flow-types/viewer';
import withViewer from 'app/common/lib/react/withViewer';
import { compose } from 'redux';
import {
  withRequestContext,
  type RequestContextType,
} from 'app/common/react/components/RequestContext';

type Props = {|
  requestContext: RequestContextType,
  viewer: Viewer,
|};

export class ZendeskChat extends Component<Props> {
  componentDidMount() {
    addZendeskScriptElement();
  }

  render() {
    return <div />;
  }
}

export default compose(
  withRequestContext,
  withViewer,
)(ZendeskChat);
